module.exports = __webpack_public_path__ + "static/media/Crater_Lake_Sky.f11a627b.jpg";